import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./ProductCardColors.module.scss";
const PREVIEWED_COLORS_COUNT = 3;
export const ProductCardColors = ({ colors = [] }) => {
    const numberOfColors = colors.length;
    const colorsToDisplay = colors.slice(0, PREVIEWED_COLORS_COUNT);
    return (_jsxs("ul", { className: styles.colorsList, children: [colorsToDisplay.map((color, index) => (_jsx("li", { className: styles.colorsListItem, "data-testid": "productCardColor", style: { backgroundColor: color } }, index))), numberOfColors > PREVIEWED_COLORS_COUNT && _jsxs("li", { children: ["+", numberOfColors - PREVIEWED_COLORS_COUNT] })] }));
};
//# sourceMappingURL=ProductCardColors.js.map